import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-kinderen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-kinderen.component.html',
  styleUrl: './tekst-kinderen.component.scss',
})
export class TekstKinderenComponent {}
